import qs from 'qs';

export const getParamsFromSearch = search => qs.parse(search ? search.slice(1) : '', {
    arrayLimit: 0,
    arrayFormat: 'brackets',
    ignoreQueryPrefix: true
});
